import React, { useState } from "react";
import styled from "styled-components";

const EditUserBox = ({ boxList, id }) => {
  const [content, setContent] = useState("");

  const lineAuto = (event, MIN_ROWS, TEXTAREA_LINE_HEIGHT) => {
    event.target.rows = MIN_ROWS;
    const currRows = ~~(event.target.scrollHeight / TEXTAREA_LINE_HEIGHT);
    event.target.rows = currRows;

    const newBoxLIst = boxList[id - 1];
    if (event.target.name === "title") {
      newBoxLIst.question = event.target.value;
    } else if (event.target.name === "content") {
      setContent(event.target.value);
      newBoxLIst.answer = event.target.value;
    }
  };

  const countWord = () => content.length;
  const countWordNoSpace = () => {
    const replaceContent = content.replace(/ |\n/gi, "");
    return replaceContent.length;
  };

  const countByte = (str) => {
    let byte = 0;
    for (let i in str) {
      str.charCodeAt(i) > 127 ? (byte += 2) : byte++;
    }
    return byte;
  };

  const countByteNoSpace = (str) => {
    const replaceStr = str.replace(/ |\n/gi, "");
    let byte = 0;
    for (let i in replaceStr) {
      replaceStr.charCodeAt(i) > 127 ? (byte += 2) : byte++;
    }
    return byte;
  };

  return (
    <>
      <ContentWrap>
        <h2>Q{id}.</h2>
        <Content>
          <TextArea
            placeholder="자소서 항목을 입력해주세요"
            rows="1"
            name="title"
            onChange={(event) => lineAuto(event, 1, 18)}
          />
        </Content>
        <Content>
          <TextArea
            placeholder="내용을 입력해주세요"
            rows="10"
            name="content"
            onChange={(event) => lineAuto(event, 10, 18)}
          />
        </Content>
        <TextCounter>
          공백포함 : 총 {countWord()}자 ({countByte(content)}byte) | 공백제외 :
          총{countWordNoSpace()}자 ({countByteNoSpace(content)}
          byte)
        </TextCounter>
      </ContentWrap>
    </>
  );
};

export default EditUserBox;
const ContentWrap = styled.div`
  max-width: 1200px;
  padding: 50px 40px;
  border: 1px solid #ddd;
  margin: 50px auto;
  h2 {
    font-size: 28px;
    margin-bottom: 20px;
    color: #7903d4;
  }
`;

const Content = styled.div`
  position: relative;
  max-width: 1200px;
  min-height: 48px;
  border: 1px solid #a5a5a5;
  padding: 16px;
  &:nth-of-type(1) {
    margin-bottom: 30px;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  border: none;
  resize: none;
  outline: 0;
  vertical-align: middle;
  font-size: 16px;
  color: "#111";
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

const TextCounter = styled.p`
  margin-top: 20px;
  color: #bbb;
  font-size: 13px;
  text-align: right;
`;
